
export const environment = {
	development: true,
	uat: false,
	staging: false,
	production: false,
	serviceURL: 'https://analytics-api.review-31.a.dev.frequence.rocks',
	build_branch_name: 'feature/AN-1433',
  build_owner_name: 'Lakshman Anadasu',
  build_date: 'March 24 2025 05:37:41 PDT',
  build_info: 'Reporting Dashboard Angular Library - Angular 15',
  build_jenkins_job_id: '5025',
  build_jenkins_job_name: 'Reporting Dashboard',
};
